import { useBilingual } from "@/lib/bilingual";

const OurFactory = () => {
  const b = useBilingual();
  const address = {
    en: "Min Tian Industrial Zone, Shatian Town, Dongguan City, Guangdong Province, China",
    zh: "廣東省東莞市沙田鎮民田工業區",
  };

  const mapSrc =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29726.04!2d113.8!3d22.75!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3403f5b0b0b0b0b1%3A0x0!2sShatian%20Town%2C%20Dongguan%2C%20Guangdong%2C%20China!5e0!3m2!1sen!2sus!4v1700000000000";

  return (
    <section className="py-14 md:py-24 bg-stone-50">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="mb-12">
          <p className="text-amber-700 text-xs font-semibold tracking-widest uppercase mb-3">
            {b("Our Factory", "我們的工廠")}
          </p>
          <h2
            className="text-3xl md:text-5xl font-bold text-stone-900 mb-6"
            style={{ fontFamily: "var(--font-display)" }}
          >
            {b("Where It All Comes Together", "製造的起點")}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          <div>
            <div className="bg-white border border-stone-200 rounded-2xl p-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-50 text-amber-700 shrink-0">
                  <i className="ri-map-pin-2-line text-lg" />
                </div>
                <div>
                  <p className="text-stone-500 text-xs uppercase tracking-widest mb-1">
                    {b("Factory Address", "工廠地址")}
                  </p>
                  <p className="text-stone-900 text-base font-semibold leading-relaxed">
                    {b(address.en, address.zh)}
                  </p>
                </div>
              </div>

            </div>
          </div>

          <div
            className="rounded-2xl overflow-hidden border border-stone-200"
            style={{ height: "360px" }}
          >
            <iframe
              title={b(
                "Forwaro Factory Location — Shatian Town, Dongguan, Guangdong, China",
                "Forwaro 工廠位置 — 廣東省東莞市沙田鎮民田工業區",
              )}
              src={mapSrc}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurFactory;
